import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAuthContext } from "@/contexts/auth";
import { useClassifiedId } from "@/contexts/classified";
import { useContactCardSection } from "@/contexts/contact";
import { useI18n } from "@/contexts/i18n";
import { useBackToSearch, useTrackingView } from "@/hooks";
import { saveContactToStorage } from "@/utils/saveContactAndSeenToStorage/saveContactAndSeenToStorage";
import { Box, useTokens } from "@gemini/core";
import { ArrowLeftIcon, MagnifyingGlassIcon } from "@gemini/icons";
import { Button, Divider, TextButton } from "@gemini/ui";
import { useEffect } from "react";
import { LoginNudge } from "./LoginNudge";
import { SimilarListings } from "./SimilarListings";
import { ConfirmIllustration } from "./UI";
export const ConfirmPage = () => {
    const { t } = useI18n();
    const tokens = useTokens();
    const { authTrackingData } = useAuthContext();
    const headerHeight = tokens["sizing.64"]; // see https://github.com/axel-springer-kugawana/aviv_whitelabel_header_footer/blob/main/white-label/src/components/header/header.tsx
    const { title: agencyTitle } = useContactCardSection();
    const isUserLoggedIn = (authTrackingData === null || authTrackingData === void 0 ? void 0 : authTrackingData.status) === "logged";
    const classifiedId = useClassifiedId();
    useEffect(() => {
        saveContactToStorage(classifiedId);
    }, [classifiedId]);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // always scroll to top on mount
    const handleBackButton = () => {
        const url = new URL(window.location.href);
        window.location.href = `${url.origin}${url.pathname}`;
    };
    const { handleBackToSearch } = useBackToSearch();
    useTrackingView();
    return (_jsxs(Box, { minHeight: `calc(100vh - ${headerHeight} - 500px)`, paddingTop: "spacing.24", maxWidth: "1280px", marginHorizontal: "auto", marginBottom: "spacing.48", display: "flex", flexDirection: "column", gap: "spacing.8", paddingHorizontal: {
            "breakpoint.base": "spacing.16",
        }, children: [_jsxs(Box, { paddingVertical: "spacing.24", children: [_jsx(TextButton, { icon: ArrowLeftIcon, iconPosition: "start", onPress: handleBackButton, marginBottom: "spacing.16", children: t("confirm_page.back_to_listing.cta.label") }), _jsxs(Box, { display: "flex", flexDirection: {
                            "breakpoint.base": "column",
                            "breakpoint.lg": "row",
                        }, justifyContent: "center", alignItems: "center", gap: "spacing.24", children: [_jsx(Box, { paddingHorizontal: "spacing.32", paddingVertical: "spacing.24", children: _jsx(ConfirmIllustration, { mainColor: tokens["color.surface.brand.primary.default"], lightColor: tokens["color.surface.active.hover"] }) }), _jsxs(Box, { display: "flex", flexDirection: "column", alignItems: {
                                    "breakpoint.base": "center",
                                    "breakpoint.lg": "flex-start",
                                }, gap: "spacing.8", children: [_jsx(Box, { typography: {
                                            "breakpoint.base": "typography.headline.24.bold",
                                            "breakpoint.lg": "typography.headline.32.bold",
                                        }, children: t("confirm_page.headline") }), _jsx(Box, { typography: {
                                            "breakpoint.base": "typography.body.16.regular",
                                            "breakpoint.lg": "typography.headline.20.regular",
                                        }, textAlign: {
                                            "breakpoint.base": "center",
                                            "breakpoint.lg": "left",
                                        }, children: t("confirm_page.body", {
                                            replace: { agencyTitle },
                                        }) }), _jsx(Button, { icon: MagnifyingGlassIcon, iconPosition: "start", onPress: handleBackToSearch, isFullWidth: {
                                            "breakpoint.base": true,
                                            "breakpoint.md": false,
                                        }, marginTop: "spacing.24", children: t("confirm_page.back_to_search.cta.label") })] })] })] }), !isUserLoggedIn && (_jsxs(_Fragment, { children: [_jsx(Divider, { marginBottom: "spacing.24", "aria-hidden": "true" }), _jsx(LoginNudge, {})] })), _jsx(Divider, {}), _jsx(Box, { borderRadius: "radius.16", minHeight: "520px", paddingVertical: "spacing.24", maxWidth: "calc(100vw - 32px)", children: _jsx(SimilarListings, {}) })] }));
};
